import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { QuillModule } from 'ngx-quill';
import { RepeatLayoutMetadata } from '../../../../model/dyn-form/form-metadata/layout/repeat-layout-metadata.model';
import { RowLayoutMetadata } from '../../../../model/dyn-form/form-metadata/layout/row-layout.metadata.model';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-repeat-form',
    templateUrl: './repeat-form.component.html',
    styleUrl: './repeat-form.component.scss',
    standalone: true,
    imports: [
        MatIconModule, MatDividerModule, CommonModule, QuillModule, MatButtonModule, MatTooltipModule,

        FormlyModule, FormlyMaterialModule
    ]
})
export class RepeatFormComponent extends FieldArrayType {

    ngOnInit(): void {
        if (this.metadata().atLeastOne) {
            super.add()
        }
    }

    override add($event: any) {
        let field: any = this.field
        if (field['metadata'] == null) {
            super.add()
            $event.stopPropagation()
            return
        }

        let rpm: RepeatLayoutMetadata = field['metadata']
        let obj: any = {}

        rpm.items.forEach(item => {
            let row = <RowLayoutMetadata>item;
            row.items.forEach(widget => {
                obj[widget.fieldName] = widget.defaultValue;
            });
        })

        super.add(this.formControl.length, obj)
        $event.stopPropagation()
    }

    metadata(): RepeatLayoutMetadata {
        let field: any = this.field
        if (field['metadata'] == null) {
            return <RepeatLayoutMetadata>{
                name: "unm",
                addLabel: "unmadd",
                description: "unm3"
            }
        }
        return field['metadata']
    }

}
